import Http from '@/ship/Http';
import { IPMChart } from '@/ship/Models/IProjectManagement';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import { IIncludedValue } from '@/ship/Values/ITransformedValue';
import { AxiosResponse } from 'axios';

export const createAnnualConstructionReport = (id: number, data: any, params?: GetRequestParams) => {
    return Http.post(`/project-management/charts/${id}/report`, data, { params });
};

export const getChartsByProject = (projectId: number): Promise<AxiosResponse<IIncludedValue<IPMChart[]>>> => {
    return Http.get(`/project-management/charts-by-project/${projectId}`);
};
